@use '@/styles/mastodon/mixins';

.root {
  border: var(--border-thin);
  border-radius: var(--radius-4);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: var(--space-3);
  position: relative;
  transition: background 200ms ease-in-out;

  &:has(.image) {
    column-gap: var(--space-3);
    display: grid;
    grid-template-columns: minmax(0, 1fr) 120px;
    padding-inline-end: 0;
  }

  &:has(.actions) {
    padding-block-end: var(--space-1);
  }
}

// Handle cases where the root is a link
a.root {
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  &:focus,
  &:focus-visible {
    border-radius: var(--radius-4);
    outline: var(--outline-focus-default);
    outline-offset: 2px;
  }
}

.title {
  @include mixins.type-meta;

  color: var(--color-text-secondary);
  display: flex;

  a {
    color: inherit;
    text-decoration: none;

    &:hover,
    &:active {
      text-decoration: underline;
    }
  }
}

.titleImage {
  border-radius: var(--radius-round);
  display: block;
  height: var(--space-5);
  margin-inline-end: var(--space-2);
  width: var(--space-5);

  > a {
    display: block;
    border-radius: var(--radius-round);
  }
}

.body {
  @include mixins.type-label;

  overflow-wrap: break-word;
  flex-grow: 1;

  * + & {
    padding-block-start: var(--space-2);
  }

  a {
    color: var(--color-text-brand);
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
}

// Linked body
a.body {
  padding-inline: var(--space-3);
  margin-inline: calc(-1 * var(--space-3));
  color: inherit;
  text-decoration: none;
  outline-offset: -2px;

  .root:has(&:hover) {
    background-color: var(--color-bg-highlight);
  }

  &:last-child {
    padding-block-end: var(--space-3);
    margin-block-end: calc(-1 * var(--space-3));
  }

  &:focus {
    border-radius: var(--radius-4);
  }
}

.description {
  @include mixins.type-body-compact;
}

.image {
  contain: size;
  grid-column: 2;
  grid-row: 1 / span 9999; // Handles unlimited space
  margin-block: calc(-1 * var(--space-3));

  > * {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}

.actions {
  @include mixins.type-label;

  padding-inline: var(--space-3);
  margin-inline: calc(-1 * var(--space-3));
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-block-start: var(--space-1);
  border-block-start: var(--border-thin);
  margin-block-start: var(--space-3);

  > span {
    margin-inline-end: var(--space-1);
  }
}

.clamp {
  @include mixins.line-clamp(2);
}

.delete {
  position: absolute;
  top: var(--space-2);
  right: var(--space-2);
}
